<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-for="estimacion in estimaciones" :key="estimacion.id">
        <h3 class="h5">{{ estimacion.nombre_programa }}</h3>
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">CÓDIGO</th>
                <th class="text-left caption">CUENTA</th>
                <th class="text-right caption">COSTO</th>
                <th class="text-right caption">SUBTOTAL GESTIÓN</th>
                <th class="text-right caption">DESERCIÓN GESTIÓN</th>
                <th class="text-right caption">TOTAL GESTIÓN</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="detalleEstimacion in estimacion.detalles_estimaciones" :key="detalleEstimacion.id">
                <td class="text-left caption">{{ detalleEstimacion.codigo }}</td>
                <td class="text-left caption">{{ detalleEstimacion.clasificador_nombre }}</td>
                <td class="text-right caption">{{ formatearNumero(detalleEstimacion.costo) }}</td>
                <td class="text-right caption">{{ formatearNumero(detalleEstimacion.subtotal_gestion) }}</td>
                <td class="text-right caption">{{ formatearNumero(detalleEstimacion.desercion_gestion) }}</td>
                <td class="text-right caption">{{ formatearNumero(detalleEstimacion.total_gestion) }}</td>
              </tr>
              <tr>
                <td></td>
                <td colspan="2" class="font-weight-bold">TOTALES</td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.detalles_estimaciones
                        .reduce((a, b) => a + parseFloat(b.subtotal_gestion), 0)
                        .toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.detalles_estimaciones
                        .reduce((a, b) => a + parseFloat(b.desercion_gestion), 0)
                        .toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.detalles_estimaciones.reduce((a, b) => a + parseFloat(b.total_gestion), 0).toFixed(2),
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../../utils.js';

export default {
  name: 'ReportePorPrograma',
  props: {
    estimaciones: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>